import React from 'react';
import * as Icons from 'lucide-react';
import { useSite } from '../../context/SiteContext';
import { scrollToAnchor } from './Navigation';
import { isVideoSrc, resolveMediaUrl } from '../admin/MediaUpload';

export default function FeatureCards() {
  const { data } = useSite();
  const handle = (f) => {
    if (!f.link) return;
    if (/^https?:/.test(f.link)) { window.open(f.link, '_blank'); return; }
    scrollToAnchor(f.link);
  };
  const cards = (data.features || []).filter(f => f.enabled !== false);
  return (
    <div className="grid grid-cols-2 gap-2.5 md:gap-3">
      {cards.map((f) => {
        const Icon = Icons[f.icon] || Icons.Star;
        const mediaIsVideo = isVideoSrc(f.image);
        const mediaUrl = resolveMediaUrl(f.image);
        return (
          <button type="button"
            key={f.id}
            onClick={() => handle(f)}
            className="flex items-center gap-3 rounded-lg border border-zinc-800 px-3.5 py-2.5 text-left click-ripple hover:border-[color:var(--gold)]/40 hover:scale-[1.01] transition-all"
            style={{ background: f.bg }}
            data-testid={`feature-card-${f.id}`}
          >
            <span className="w-10 h-10 rounded-full bg-[color:var(--gold)]/20 flex items-center justify-center text-[color:var(--gold)] overflow-hidden shrink-0">
              {f.image ? (
                mediaIsVideo ? (
                  <video key={mediaUrl} src={mediaUrl} autoPlay muted loop playsInline className="w-full h-full object-cover" />
                ) : (
                  <img key={mediaUrl} src={mediaUrl} alt="" className="w-full h-full object-cover" />
                )
              ) : (
                <Icon size={18} />
              )}
            </span>
            <div className="min-w-0">
              <div className="text-white font-bold text-sm truncate">{f.label}</div>
              <div className="text-zinc-400 text-[11px] truncate">{f.sub}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
